// src/hooks/useRolls.js
import { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import axios from "axios";

export default function useRolls(globalData) {
  const [rawData, setRawData] = useState({});
  const [rawRows, setRawRows] = useState([]);
  const [roll, setRoll] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const db = getDatabase();

  useEffect(() => {
    const rollsRef = ref(db, "/rolls_remodel/");
    const unsubscribe = onValue(rollsRef, (snapshot) => {
      let result = snapshot.val();
      setRawData(result || {});

      if (!result) {
        setIsInitialLoading(false);
        return;
      }

      const years = Object.keys(result || {});
      let allRolls = [];

      years.forEach((year) => {
        const months = Object.keys(result[year] || {});
        months.forEach((month) => {
          const companies = Object.keys(result[year][month] || {});
          companies.forEach((company) => {
            const departments = Object.keys(result[year][month][company] || {});
            departments.forEach((department) => {
              const dateTimes = Object.keys(
                result[year][month][company][department] || {}
              );

              // agrupar por originalTime
              const groupedByOriginalTime = {};
              dateTimes.forEach((dateTimeKey) => {
                const rollData =
                  result[year][month][company][department][dateTimeKey];
                if (!rollData?.originalTime || !rollData?.registeredDateTime)
                  return;

                const timeKey = rollData.originalTime;
                if (!groupedByOriginalTime[timeKey]) {
                  groupedByOriginalTime[timeKey] = [];
                }
                groupedByOriginalTime[timeKey].push({
                  ...rollData,
                  keyDate: dateTimeKey,
                });
              });

              // pegar sempre o mais recente
              Object.values(groupedByOriginalTime).forEach((rollsAtTime) => {
                let latestRoll = null;
                let latestDate = null;

                rollsAtTime.forEach((rollData) => {
                  const rollDate = new Date(
                    rollData.registeredDateTime.replace(
                      /(\d{2})-(\d{2})-(\d{4})-(\d{2}):(\d{2}):(\d{2})/,
                      "$3-$2-$1T$4:$5:$6"
                    )
                  );
                  if (!latestDate || rollDate > latestDate) {
                    latestDate = rollDate;
                    latestRoll = rollData;
                  }
                });

                if (latestRoll) {
                  try {
                    const registeredDate = new Date(
                      latestRoll.registeredDateTime.replace(
                        /(\d{2})-(\d{2})-(\d{4})-(\d{2}):(\d{2}):(\d{2})/,
                        "$3-$2-$1T$4:$5:$6"
                      )
                    );

                    allRolls.push({
                      uid: latestRoll.userId || "",
                      instructor:
                        latestRoll.instructor || "Instrutor desconhecido",
                      company,
                      department,
                      registeredDate,
                      dateTime: registeredDate,
                      registeredDateTime: latestRoll.registeredDateTime,
                      originalTime: latestRoll.originalTime,
                      keyDate: latestRoll.keyDate,
                      sessionRoll: latestRoll.sessionRoll || 2,
                      year,
                      month,
                    });
                  } catch (e) {
                    console.error("Erro ao processar sessão:", e);
                  }
                }
              });
            });
          });
        });
      });

      const uniqueUids = [
        ...new Set(allRolls.map((r) => r.uid).filter(Boolean)),
      ];

      if (uniqueUids.length > 0) {
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${globalData.apiHost}/users`,
          headers: {
            "Content-Type": "application/json",
            Authorization: process.env.REACT_APP_BACKEND_SECRET,
          },
          data: uniqueUids,
        };

        axios
          .request(config)
          .then((response) => {
            const teachersMap = {};
            response.data.users.forEach((teacher) => {
              teachersMap[teacher.uid] = teacher.displayName || "Sem nome";
            });

            const rollsWithNames = allRolls.map((roll) => ({
              ...roll,
              instructor: teachersMap[roll.uid] || roll.instructor,
            }));

            const sortedRolls = rollsWithNames.sort(
              (a, b) => b.registeredDate - a.registeredDate
            );

            setRawRows(sortedRolls);

            if (globalData.role !== "admin" && globalData.company) {
              const companyFiltered = sortedRolls.filter(
                (row) => row.company === globalData.company
              );
              setRoll(companyFiltered);
              setFilteredRows(companyFiltered);
              setSelectedCompany(globalData.company);
            } else {
              setRoll(sortedRolls);
              setFilteredRows(sortedRolls);
            }

            setIsInitialLoading(false);
          })
          .catch(() => {
            setIsInitialLoading(false);
          });
      } else {
        const sortedRolls = allRolls.sort(
          (a, b) => b.registeredDate - a.registeredDate
        );
        setRawRows(sortedRolls);
        setRoll(sortedRolls);
        setFilteredRows(sortedRolls);
        setIsInitialLoading(false);
      }
    });

    return () => unsubscribe();
  }, [db, globalData]);

  return {
    rawData,
    rawRows,
    roll,
    filteredRows,
    selectedCompany,
    setSelectedCompany,
    isInitialLoading,
    setFilteredRows,
    setRoll,
  };
}
